import { shouldMockExternalApis } from './shouldMockExternalApis'
import { IEnvironmentSettings, ISettingsForClient } from './types'

declare const EnvironmentSettings: IEnvironmentSettings
declare const SettingsForClient: ISettingsForClient

export namespace GlobalVariables {
  function getEnvironmentSettings(): IEnvironmentSettings {
    // When running locally, we want to allow for the global variables to not be present
    // tslint:disable-next-line:no-typeof-undefined
    if (shouldMockExternalApis() || typeof(EnvironmentSettings) === 'undefined') {
      return {
        version: 'LOCALTESTVERSION',
        ring: 'LOCALRING',
        ExampleSettingOnlyTrueInInternal: true,
        correlationId: '02db5f19-df21-4fad-bf66-77859ce509b1',
        sessionId: 'd5d6b170-6ddb-4a41-825f-a117b7efbd85',
      }
    } else {
      return EnvironmentSettings
    }
  }

  export const environmentSettings: IEnvironmentSettings = getEnvironmentSettings()

  function getSettingsForClient(): ISettingsForClient {
    // tslint:disable-next-line:no-typeof-undefined
    if (shouldMockExternalApis() || typeof(SettingsForClient) === 'undefined') {
      return {
        Locale: 'de-de', // You can change this to change the value of the local language
        ServerSidePerfMetrics: { 'Start' : 0 },
        GraphResourceUri: 'https://graph.microsoft.com',
        OutlookResourceUri: 'https://outlook.office365.com',
        OneNoteResourceUri: 'https://onenote.com/',
      }
    }
    return SettingsForClient
  }

  export const settingsForClient: ISettingsForClient = getSettingsForClient()
}
